import { getAnalyticsService, AnalyticsEvent } from './index';

export interface TrackFiltersChangedOptions {
  changedFilters: string[];
  filterState: Record<string, unknown>;
  rowsVisibleCount: number;
  interactionIndex: number;
}

export const trackFiltersChanged = ({
  changedFilters,
  filterState,
  rowsVisibleCount,
  interactionIndex,
}: TrackFiltersChangedOptions): void => {
  const service = getAnalyticsService();
  service.trackEvent(AnalyticsEvent.FiltersChanged, {
    changed_filters: changedFilters,
    filter_state: filterState,
    rows_visible_count: rowsVisibleCount,
    interaction_index: interactionIndex,
  });
};
